import { Funnel, FunnelChart, Tooltip, ResponsiveContainer, LabelList, Cell } from 'recharts';
import { Card, CardContent } from '~/components/ui/card';
import type { IFunnelStage } from '~/types';

interface IFunnelVisualizationProps {
  stages: IFunnelStage[];
}

const FUNNEL_COLORS = ['#0070c9', '#38bdf8', '#f59e0b', '#22c55e'];

export const FunnelVisualization = ({ stages }: IFunnelVisualizationProps) => {
  if (stages.length === 0) {
    return (
      <Card>
        <CardContent className="flex h-64 items-center justify-center text-muted-foreground">
          No data available
        </CardContent>
      </Card>
    );
  }

  const chartData = stages.map((stage) => ({
    name: stage.label,
    value: stage.count,
    percentage: stage.percentage,
  }));

  return (
    <Card>
      <CardContent className="pt-6">
        {/* Stage header pills */}
        <div className="flex items-center justify-between mb-6">
          {stages.map((stage, i) => (
            <div key={stage.label} className="flex items-center gap-2 text-sm">
              {i > 0 && <span className="text-muted-foreground mx-2">&rarr;</span>}
              <div className="text-center">
                <p className="font-semibold text-lg">{stage.count.toLocaleString()}</p>
                <p className="text-muted-foreground text-xs">{stage.label}</p>
                <p className="text-muted-foreground text-xs">{stage.percentage}%</p>
              </div>
            </div>
          ))}
        </div>

        <ResponsiveContainer width="100%" height={280}>
          <FunnelChart>
            <Tooltip />
            <Funnel dataKey="value" data={chartData} isAnimationActive>
              {chartData.map((_entry, index) => (
                <Cell key={`cell-${index}`} fill={FUNNEL_COLORS[index % FUNNEL_COLORS.length]} />
              ))}
              <LabelList position="center" fill="#fff" stroke="none" fontSize={14} fontWeight={600} dataKey="name" />
            </Funnel>
          </FunnelChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
